module.exports = __webpack_public_path__ + "img/9.a4085ab.svg";